<template>
	<div :id="id" ref="swipertest" v-show="!hidden">
		<a
			v-for="(image, key) in images"
			:key="key"
			:href="image.url"
			:data-pswp-width="image.width"
			:data-pswp-height="image.height"
			target="_blank"
			rel="noreferrer"
		>
			<img :src="image.url" />
		</a>
	</div>
</template>

<script>
import { provide, ref, onMounted, nextTick } from 'vue';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

export default {
	name: 'ImageSwiper',
	props: {
		id: {
			type: String,
			default: 'entry-media-swiper'
		},
		images: {
			type: Array,
			required: true
		},
		hidden: {
			type: Boolean,
			default: false
		}
	},	
	setup(props) {
		const lightbox = ref(null);
		const hidden = ref(false);
		
		//const initLightbox = () => {
		const initLightbox = () => {
			

			lightbox.value = new PhotoSwipeLightbox({
				gallery: '#' + props.id,
				children: 'a',
				pswpModule: () => import('photoswipe'),
				});
		
			lightbox.value.init();
			lightbox.value.loadAndOpen(1);

		};
		
		// Initialize the PhotoSwipeLightbox when the component is mounted
		onMounted(() => {
				if(!hidden) {
					initLightbox();
				}
		});

		return {
				initLightbox
		};
	}
};
</script>

<style>
</style>